import { render } from "./ConfigurationInfoIgnoreList.vue?vue&type=template&id=7d8aa29f&scoped=true"
import script from "./ConfigurationInfoIgnoreList.vue?vue&type=script&lang=js"
export * from "./ConfigurationInfoIgnoreList.vue?vue&type=script&lang=js"

import "./ConfigurationInfoIgnoreList.vue?vue&type=style&index=0&id=7d8aa29f&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8aa29f"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
